import { useRef } from "react";
import { motion, useScroll, useTransform, useInView } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0, stagger = 0.12, inView = false }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-60px" });
  const active = inView ? seen : true;
  return (
    <span ref={ref} className={`block ${className}`}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.16em] -mb-[0.16em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: active ? "0%" : "115%" }}
            transition={{ duration: 1.1, ease: EASE, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, y = 18, className = "", ...rest }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-40px" });
  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={seen ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.8, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const ParallaxImage = ({ src, alt = "", className = "", imgClassName = "", eager = false }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-40px" });
  return (
    <motion.div
      ref={ref}
      className={`overflow-hidden ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: seen ? 1 : 0 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
    >
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} className={`h-full w-full object-cover ${imgClassName}`} />
    </motion.div>
  );
};

export const ClipReveal = ({ src, alt = "", className = "", imgClassName = "", delay = 0, eager = false, onClick, testid }) => {
  const ref = useRef(null);
  const seen = useInView(ref, { once: true, margin: "-40px" });
  return (
    <motion.div
      ref={ref}
      className={`overflow-hidden ${className} ${onClick ? "cursor-pointer" : ""}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: seen ? 1 : 0 }}
      transition={{ duration: 0.8, ease: "easeOut", delay }}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      data-testid={testid}
    >
      <img src={src} alt={alt} loading={eager ? "eager" : "lazy"} className={`h-full w-full object-cover ${imgClassName}`} />
    </motion.div>
  );
};
